import styled from 'styled-components'

import { COLOR } from 'styles/constants'

const MarkerBubble = styled.div`
  /* Position the bubble centred-above its parent. */
  position: absolute;
  top: 0;
  left: 0;
  transform: translate(-50%, -100%);

  /* Style the bubble. */
  background-color: white;
  padding: 1px 10px;
  font-family: 'Poppins';
  overflow-y: auto;
  max-height: 60px;
  box-shadow: 0px 2px 7px rgba(0, 0, 0, 0.1);
  width: fit-content;

  text-align: initial;
  color: white;

  border: 1px solid ${COLOR.BLUE_LV3};
  background-color: ${COLOR.BLUE_LV3};
  border-radius: 12px;
  font-size: 14px;
  font-weight: 600;
`

const Anchor = styled.div`
  cursor: pointer;
  position: absolute;
  width: 100%;
  bottom: 8px;
  left: 0;
  &:after {
    content: ' ';
    position: absolute;
    top: 0;
    left: 0;

    /* Center the tip horizontally. */
    transform: translate(-50%, 0);

    /* The tip is a https://css-tricks.com/snippets/css/css-triangle/ */
    width: 0;
    height: 0;

    /* The tip is 8px high, and 12px wide. */
    border-left: 6px solid transparent;
    border-right: 6px solid transparent;
    border-top: 8px solid ${COLOR.BLUE_LV3};
  }
`
interface IMarkerInfo {
  text: string
}

export const MarkerInfo = ({ text }: IMarkerInfo) => (
  <Anchor>
    <MarkerBubble>{text}</MarkerBubble>
  </Anchor>
)
